import { Component, Input, } from '@angular/core';

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ModalComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    selector: 'assetTypeRowModal',
    styleUrls: [],
    template : '<tr class="row">\n    <td class="col-2">{{assetType.practice_type_code_display}}</td>\n    <td class="col-2">{{assetType.business_rule_starts_with == null ? (assetType.business_rule_range == null ? \'Any\' : assetType.business_rule_range) : assetType.business_rule_starts_with}}</td>\n    <td class="col-8">{{assetType.business_rule_description + \' (\' + assetType.practice_type_code + \')\'}}</td>\n</tr>\n'
})
export class AssetTypeRowModalComponent {

    //==================================
    // constructor
    //==================================
    constructor() { }

    @Input("assetType") assetType; 

}